"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class WidgetBoard extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'widgetBoard';
        this._columnData = initParams.column_data;
        this._columnOrder = (0, util_1.camelArray)(initParams.column_order);
        this._dateData = initParams.date_data;
        this._itemType = initParams.item_type;
        this._itemId = initParams.item_id;
    }
    set columnData(value) {
        console.error('Do not set objects this way');
    }
    setColumnData(value) {
        return this.dataService.updateWidgetBoard(this.id, { column_data: value }, this);
    }
    get columnData() {
        return this._columnData;
    }
    set columnOrder(value) {
        console.error('Do not set objects this way');
    }
    setColumnOrder(value) {
        return this.dataService.updateWidgetBoard(this.id, { column_order: (0, util_1.snakeArray)(value) }, this);
    }
    get columnOrder() {
        return this._columnOrder;
    }
    set dateData(value) {
        console.error('Do not set objects this way');
    }
    setDateData(value) {
        return this.dataService.updateWidgetBoard(this.id, { date_data: value }, this);
    }
    get dateData() {
        return this._dateData;
    }
    set itemType(value) {
        console.error('Do not set objects this way');
    }
    setItemType(value) {
        return this.dataService.updateWidgetBoard(this.id, { item_type: value }, this);
    }
    get itemType() {
        return this._itemType;
    }
    set itemId(value) {
        console.error('Do not set objects this way');
    }
    setItemId(value) {
        return this.dataService.updateWidgetBoard(this.id, { item_id: value }, this);
    }
    get itemId() {
        return this._itemId;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateWidgetBoard(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = WidgetBoard;
//# sourceMappingURL=widgetBoard.js.map